<template>
  <div>
    <div class="set-block">
      <div class="set-title">学校编码</div>
      <Form
        label-position="left"
        :label-width="100"
      >
        <FormItem v-if="updateSchoolCode" label="学校编号：">
          <Row>
            <Col span="10">
              <Input
                v-model="schoolCodeInput"
                maxlength="5"
                placeholder="请输入学校编码"
              ></Input>
            </Col>
            <Col offset="1" span="8">
              <Button :loading="codeBtnLoading" @click="handleEditCode(false)">取消</Button>
              <Button :loading="codeBtnLoading" type="primary" @click="handleSaveCode">保存</Button>
            </Col>
          </Row>
          <p class="color-gray font-small">
            限制5位数字，设置后不可变更！
          </p>
        </FormItem>
        <FormItem v-else label="学校编号：">
          <Row>
            <Col span="10">
              <span class="content-content">{{ schoolCode||'暂未设置' }}</span>

            </Col>
            <Col v-if="!schoolCode" offset="1" span="8">
              <Button type="primary" @click="handleEditCode(true)">编辑</Button>
            </Col>
          </Row>
          <p class="color-gray font-small">
            限制5位数字
          </p>
        </FormItem>
      </Form>
    </div>
    <div class="set-block">
      <div class="set-title">家长自助注册截止时间</div>
      <Form
        label-position="left"
        :label-width="100"
      >
        <FormItem v-if="updateLimitTime" label="截止日期：">
          <Row>
            <Col span="10">
              <DatePicker :clearable="false" :value="limitTimeInput" type="datetime" placeholder="请选择截止日期" transfer @on-change="getTimeInput"></DatePicker>
            </Col>
            <Col offset="1" span="8">
              <Button :loading="timeBtnLoading" @click="handleEditTime(false)">取消</Button>
              <Button :loading="timeBtnLoading" type="primary" @click="handleSaveTime">保存</Button>
            </Col>
          </Row>
        </FormItem>
        <FormItem v-else label="截止日期：">
          <Row>
            <Col span="10">
              <span class="content-content">{{ limitTime||'暂未设置' }}</span>

            </Col>
            <Col offset="1" span="8">
              <Button type="primary" @click="handleEditTime(true)">编辑</Button>
            </Col>
          </Row>
          <p class="color-gray font-small">
            配置后，家长端将在该时间之后，无法再通过【{{ projectName }}】进行自行绑定！
          </p>
        </FormItem>
      </Form>
    </div>
    <div class="set-block">
      <div class="set-title">家长自主绑定验证条件</div>
      <div class="set-content">

        <div v-if="updateLimitCondition" class="content-line-edit">
          <CheckboxGroup v-model="conditionGroupSelect">
            <Checkbox label="1">需验证绑定截止时间</Checkbox>
            <Checkbox label="2">需输入验证学校编码</Checkbox>
          </CheckboxGroup>
          <Button :loading="conditionLoading" @click="handleEditCondition(false)">取消</Button>
          <Button :loading="conditionLoading" type="primary" @click="handleSaveCondition">保存</Button>
        </div>
        <div v-else class="content-line-finish">
          <CheckboxGroup v-model="conditionGroup">
            <Checkbox label="1" disabled>需验证绑定截止时间</Checkbox>
            <Checkbox label="2" disabled>需输入验证学校编码</Checkbox>
          </CheckboxGroup>
          <Button type="primary" @click="handleEditCondition(true)">编辑</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import commonApi from '@/request/common/index.js';
export default {
  props: {
    orgId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      schoolCode: '', // 学校编号
      schoolCodeInput: '', // 拿到的000243
      limitTime: '', // 限制时间
      limitTimeInput: '', //
      conditionGroup: [], // 限制条件
      conditionGroupSelect: [], // 限制条件
      updateSchoolCode: false,
      updateLimitTime: false,
      updateLimitCondition: false,
      codeBtnLoading: false,
      timeBtnLoading: false,
      conditionLoading: false
    };
  },
  computed: {
    ...mapState(['projectName'])
  },
  created() {
    console.log('拿到了吗--34created');
    this.getInfo();
  },
  methods: {
    handleEditCode(status) {
      this.updateSchoolCode = status;
      if (this.updateSchoolCode) {
        this.schoolCodeInput = this.schoolCode;
      }
    },
    handleEditTime(status) {
      this.updateLimitTime = status;
      if (this.updateLimitTime) {
        this.limitTimeInput = this.limitTime;
      }
    },
    handleEditCondition(status) {
      this.updateLimitCondition = status;
      if (this.updateLimitCondition) {
        this.conditionGroupSelect = this.conditionGroup;
      }
    },
    async getInfo() {
      const params = {
        orgId: this.orgId
      };
      this.schoolCode = '';
      this.limitTime = '';
      this.conditionGroup = [];
      const res = await commonApi.getListOrgInfoApi(params);
      if (res.status === 200) {
        res.message.forEach(item => {
          switch (item.codeType) {
            case 'SCHOOL_CODE':
              this.schoolCode = item.codeName;
              break;
            case 'REGISTER_LIMIT_DATE':
              this.limitTime = item.codeName;
              break;
            case 'REGISTER_LIMIT_CONDITION':
              if (item.codeName === '3') {
                this.conditionGroup = ['1', '2'];
              } else if (item.codeName === '1' || item.codeName === '2') {
                this.conditionGroup = [item.codeName];
              }
              break;
          }
        });
      }
    },
    async handleSaveCode() {
      if (this.schoolCodeInput.length !== 5 || isNaN(this.schoolCodeInput)) {
        this.$Message.error('限制5位数字');
        return;
      }
      const params = {
        schoolCode: this.schoolCodeInput,
        orgId: this.orgId
      };
      this.codeBtnLoading = true;
      const res = await commonApi.updateSchoolCodeApi(params);
      if (res.status === 200) {
        this.$Message.success('编辑成功');
        this.getInfo();
        this.updateSchoolCode = false;
        this.codeBtnLoading = false;
      }
    },
    getTimeInput(e) {
      console.log(e, '拿到的0043223');
      this.limitTimeInput = e;
    },
    async handleSaveTime() {
      const params = {
        limitTime: this.limitTimeInput,
        orgId: this.orgId
      };
      this.timeBtnLoading = true;
      const res = await commonApi.updateLimitTimeApi(params);
      if (res.status === 200) {
        this.$Message.success('编辑成功');
        this.getInfo();
        this.updateLimitTime = false;
        this.timeBtnLoading = false;
      }
    },
    async handleSaveCondition() {
      const condition = this.conditionGroupSelect.reduce((pre, current) => {
        return pre + +current;
      }, 0);
      console.log(condition, '拿到的');
      const params = {
        condition: condition,
        orgId: this.orgId
      };
      this.conditionLoading = true;
      const res = await commonApi.updateLimitConditionApi(params);
      if (res.status === 200) {
        this.$Message.success('编辑成功');
        this.getInfo();
        this.updateLimitCondition = false;
        this.conditionLoading = false;
      }
    }

  }
};
</script>
<style lang="scss" scoped>
.set-title{
  font-weight: bold;
  color: #333;
  font-size: 20px;
  line-height: 50px;
}
.set-block{
  /deep/.ivu-form-item-label{
    // font-weight: bold;
    font-size: 16px;
    color: #333;
  }
  .content-content{
    // font-weight: bold;
    font-size: 16px;
    color: #333;
  }
}
.set-content{
  display: flex;
  align-items: center;
  .content-line-edit{
    display: flex;
    align-items: center;
  }
  .content-line-finish{
    display: flex;
    align-items: center;
  }
  button{
    margin-left: 10px;
  }
}
button+button{
  margin-left: 10px;
}
</style>
